<template>
	<section class="small-12 policiesNav articlesNav">
        <ul class="float-left small-12 flex justify-center">
            <li class="auto">
                <a class="auto float-left small-12 columns">
                    About Nestd
                </a>
            </li>
        </ul>
    </section>
</template>

<script>
	
	export default {

		/*
		** Set the component name
		*/

		name: 'BlogNav',

		/*
		**  Register the components
		*/

		components: {

			//

		},

		/*
		**  Register the mixins
		*/

		mixins: [

			//

		],

		/*
		**  Set the props
		*/

		props: {

			//

		},

		/*
		**  Set up the data
		*/

		data: () => ({

			//

		}),

		/*
		**  Watch em'
		*/

		watch: {

			//

		},

		/*
        ** Do this first
        */

        mounted() {

        	//

        },

        /*
		**  Set up the methods
		*/

		methods: {

			//

		},

		/*
		**  Set the computed props
		*/

		computed: {

			//

		},

		/*
		**  Set the filters
		*/

		filters: {

			//

		}

	}

</script>